import React from 'react';
import spinner from './assets/spinner.svg';
import styles from './LoadingState.module.css';

export default function LoadingState() {
  return (
    <div className={styles.container}>
      <div className={styles.loadingContent}>
        <div className={styles.spinner}>
          <img src={spinner} alt="spinner" className={styles.spinnerArc} />
        </div>
        <p className={styles.loadingText}>Loading available appointment times...</p>
      </div>
    </div>
  );
}
